import { FetchApiResponse } from "redux/types";

export enum UnRealisedIncomeReduxTypes {
    UNREALISED_INCOME_REPORT = "@@auth/UNREALISED_INCOME_REPORT",
    UNREALISED_INCOME_REPORT_SUCCESS = "@@auth/UNREALISED_INCOME_REPORT_SUCCESS",
    UNREALISED_INCOME_REPORT_ERROR = "@@auth/UNREALISED_INCOME_REPORT_ERROR"
}

export type UnRealisedIncomeActionDispatch = {
    type: | UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT;
    payload: any;
}

export type UnRealisedIncomeReducerDispatch = {
    type: | UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT
    | UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_SUCCESS
    | UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_ERROR

    payload: {
        data?: FetchApiResponse<UnRealisedIncomeReport>
        error?: string
    }
}

export type UnRealisedIncomeReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateUnRealisedIncomeReportRequest = {
    payload: {},
    type: string
}

export type CreateUnRealisedIncomeReportReduxState = {
    loading?: boolean
    data?: {},
    error?: string | null;
}